/**
 * Portal Conversations view (SPEC E4 R3 — DEGRADED placeholder).
 *
 * Per the BEFORE-RUN amendment: the conversations view degrades to a
 * "coming soon" placeholder because E1c (the unified inbox) is not built yet.
 * This is intentional and additive — the view is wired and reachable when the
 * tenant enables it, but renders a calm placeholder rather than a half-built
 * thread list. When E1c ships, this component swaps to the real read-only
 * thread list (the SmsConversation component, adapted read-only).
 */

export function PortalConversations() {
  return (
    <div
      className="rounded-md border border-dashed p-8 text-center"
      data-testid="conversations-coming-soon"
    >
      <p className="text-sm font-medium text-foreground">Conversations coming soon</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Your message history with leads will appear here.
      </p>
    </div>
  )
}
